import React from 'react'
import logo from '../../assets/img/logo-new.svg'
import moment from 'moment'
import { formatNumber } from '../functions'

const BasicPayslipPDFContent = (company, payslip, imageBlob = null) => {
  return (
    <div className='w-full relative min-h-screen bg-white p-8'>
      <div className='max-w-7xl mx-auto space-y-6'>
        {/* Company Info */}
        <div className='flex flex-col gap-4 items-start'>
          <>
            {imageBlob ? (
              <img
                src={imageBlob}
                alt='company_logo'
                className='w-[170px] h-[60px]'
              />
            ) : (
              <div className='bg-hr-primary-1 h-14 w-14 rounded-full flex justify-center items-center'>
                <span className=' text-white text-2xl font-bold pb-4 flex'>
                  {company?.company_name?.charAt(0)}
                </span>
              </div>
            )}
          </>
          <div className='flex flex-col gap-1'>
            <p className='text-lg text-hr-primary-1 font-semibold'>
              {company?.company_name}
            </p>
            <p className='text-base text-hr-primary-1 font-normal'>
              {company?.address}, {company?.country}
            </p>
            <p className='text-base text-hr-primary-1 font-normal'>
              {company?.email} {company?.email ? '|' : null} {company?.mobile}
            </p>
          </div>
        </div>
        <div className='flex flex-col gap-2'>
          <p className='text-black font-medium'>Employee Payment Summary</p>
          <p className='text-black/40 text-sm'>
            Name{' '}
            <span className='text-black font-medium'>
              {payslip.employee_first_name} {payslip.employee_last_name}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Email{' '}
            <span className='text-black font-medium'>
              {payslip.employee_email}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Phone:{' '}
            <span className='text-black font-medium'>
              {payslip.employee_phone}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Date of payment:{' '}
            <span className='text-black font-medium'>
              {moment(payslip.processed_date).format('MMMM DD, YYYY')}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Bank Name:{' '}
            <span className='text-black font-medium'> {payslip.bank_name}</span>
          </p>
          <p className='text-black/40 text-sm'>
            Account Number:{' '}
            <span className='text-black font-medium'>
              {payslip.account_number}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Account Name:{' '}
            <span className='text-black font-medium'>
              {payslip.account_name}
            </span>
          </p>
          <p className='text-black/40 text-sm'>
            Amount Paid:{' '}
            <span className='text-black font-medium'>
              {' '}
              {formatNumber(payslip?.net_pay)}
            </span>
          </p>
          <div className='text-black/40 flex items-center gap-1 text-sm'>
            <span> Status </span>
            <div
              className={`px-2 py-1 w-[130px] h-[40px] flex items-center text-center rounded-md ${
                payslip.status === 0
                  ? 'text-color-orange bg-color-orange-light  border-color-orange'
                  : payslip.status === 1
                  ? 'text-color-green-medium bg-color-green-light border-[1px] border-color-green-medium'
                  : 'text-color-error bg-color-error-light border-color-error'
              }`}
            >
              {payslip?.status === 0
                ? 'Pending'
                : payslip.status === 1
                ? 'Successful'
                : 'Failed'}
            </div>
          </div>
        </div>
        {/* Add android and ios button  */}
        <section className='absolute mt-[100px] bottom-5 left-1/2 -translate-x-1/2 -translate-y-1/2'>
          <div className='flex justify-center items-center space-x-4'>
            <a
              href='https://play.google.com/store/apps/details?id=com.ropay.app&hl=en'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src='/playstore.png'
                alt='Google Play Badge'
                className='h-12'
              />
            </a>
            <a
              href='https://apps.apple.com/ng/app/centelhr/id6743995408'
              target='_blank'
              rel='noreferrer'
            >
              <img src='/appstore.png' alt='App Store Badge' className='h-12' />
            </a>
          </div>
          {/* Footer */}
          <a
            href='https://centelhr.com'
            target='_blank'
            rel='noreferrer'
            className='text-sm text-center text-[#001984] font-normal'
          >
            <div className='text-center space-y-2'>
              <p className='text-sm font-normal'>Powered By</p>
              <img src={logo} alt='CentelHr Logo' className='h-8 mx-auto' />
            </div>
          </a>
        </section>
      </div>
    </div>
  )
}

export default BasicPayslipPDFContent
